<template>
   <blank-layout>
      <v-row>
         <v-col cols="12" lg="7" xl="6" class="info d-none d-md-flex align-center justify-center">
            <v-container>
            <div class="pa-10">
               <v-row justify="center">
                  <v-col cols="8" xl="5">
                  <div>
                     <div class="text-center">
                        <v-avatar color="white" width="150" height="150">
                           <img src="@/assets/images/miplogo-300x300.png">
                        </v-avatar>
                     </div>
                     <br>
                     <h2 class="display-1 white--text font-weight-medium">
                        MIP Online Membership System
                     </h2>
                     <!-- <h6 class="subtitle-1 mt-4 white--text op-5 font-weight-regular">
                        Some introduction description about the system. Build using Laravel 8 JetStream with AdminPro Template. Vue.JS front-end with Laravel 8 back-end.
                     </h6>
                     <v-btn class="mt-4 text-capitalize" x-large outlined color="white">Learn More</v-btn> -->
                  </div>
                  </v-col>
               </v-row>
            </div>
            </v-container>
         </v-col>
         <v-col cols="12" lg="5" xl="6" class="d-flex align-center">
            <v-container>
            <div class="pa-7 pa-sm-12">
               <v-row>
                  <v-col cols="12" lg="9" xl="6">
                  <!-- <img src="@/assets/images/logo-icon.png" /> -->
                  <h2 class="font-weight-bold mt-4 blue-grey--text text--darken-2">Sign Up</h2>
                  <h6 class="subtitle-1">
                     Already have an account?
                     <a href="/member-login" class>Sign in</a>
                  </h6>

                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="register">
                     <v-alert
                        v-if="errormsg"
                        type="error"
                        dense
                        text
                        class="mt-4 mb-2"
                     >
                        {{ errormsg }}
                     </v-alert>
                     <v-text-field
                        v-model="fname"
                        :rules="fnameRules"
                        :error-messages="fieldErrors.name"
                        label="Full Name"
                        class="mt-4"
                        required
                        outlined
                     ></v-text-field>
                     <v-text-field
                        v-model="icno"
                        :rules="icnoRules"
                        :error-messages="fieldErrors.icno"
                        label="IC / Passport No."
                        required
                        outlined
                        @input="onIcInput"
                     ></v-text-field>
                     <v-text-field
                        v-model="email"
                        :rules="emailRules"
                        :error-messages="fieldErrors.email"
                        label="E-mail"
                        required
                        outlined
                     ></v-text-field>
                     <v-text-field
                        v-model="password"
                        :counter="15"
                        :rules="passwordRules"
                        :error-messages="fieldErrors.password"
                        label="Password"
                        required
                        outlined
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPassword ? 'text' : 'password'"
                        @click:append="showPassword = !showPassword"
                     ></v-text-field>
                     <v-text-field
                        v-model="confirm_password"
                        :counter="15"
                        :rules="confirm_passwordRules"
                        :error-messages="fieldErrors.password_confirmation"
                        label="Confirm Password"
                        required
                        outlined
                        :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showConfirmPassword ? 'text' : 'password'"
                        @click:append="showConfirmPassword = !showConfirmPassword"
                     ></v-text-field>
                     <div class="d-block d-sm-flex align-center mb-4 mb-sm-0">
                        <v-checkbox
                        v-model="checkbox"
                        :rules="[v => !!v || 'You must agree to continue!']"
                        label="I agree to the terms and privacy"
                        required
                        ></v-checkbox>
                     </div>
                     <v-btn
                        :disabled="submitting"
                        :loading="submitting"
                        color="info"
                        block
                        class="mr-4"
                        type="button"
                        @click="register"
                     >Register</v-btn>
                  </v-form>
                  <!-- <div class="text-center mt-6">
                     <v-chip pill class="mr-2">
                        <v-avatar left>
                        <v-btn color="blue lighten-1" class="white--text">
                           <v-icon>mdi-twitter</v-icon>
                        </v-btn>
                        </v-avatar>Twitter
                     </v-chip>
                     <v-chip pill>
                        <v-avatar left>
                        <v-btn color="teal lighten-2" class="white--text">
                           <v-icon>mdi-github</v-icon>
                        </v-btn>
                        </v-avatar>Github
                     </v-chip>
                  </div> -->
                  </v-col>
               </v-row>
            </div>
            </v-container>
         </v-col>
   </v-row>
  </blank-layout>
</template>

<script>
import BlankLayout from '@/Layouts/BlankLayout.vue';

export default {
   name: 'MOMRegister',
   components: {
      BlankLayout,
   },
   props: {
      errors: {
         type: Object,
         default: () => ({})
      }
   },
   data() {
      return {
         submitting: false,
         errormsg: "",
         fieldErrors: {},
         password: "",
         confirm_password: "",
         showPassword: false,
         showConfirmPassword: false,
         passwordRules: [
            v => !!v || "Password is required",
            v => (v && v.length >= 8) || "Password must be at least 8 characters",
            v => /(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/.test(v) || "Must use a strong password combination of characters. Upper-case, lower-case, numbers and symbols"
         ],
         confirm_passwordRules: [
            v => !!v || "Confirm Password is required",
            v => (v === this.password) || 'Confirm password must be equal to password value',
            v => (v && v.length >= 8) || "Password must be at least 8 characters",
            v => /(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/.test(v) || "Must use a strong password combination characters. Upper-case, lower-case, numbers and symbols"
         ],
         email: "",
         emailRules: [
            v => !!v || "E-mail is required",
            v => /.+@.+\..+/.test(v) || "E-mail must be valid"
         ],
         valid: false,
         checkbox: false,
         fname: "",
         fnameRules: [
            v => !!v || "Name is required",
            // v => (v && v.length <= 10) || "Name must be more than 10 characters"
         ],
         icno: "",
         icnoRules: [
            v => !!v || "IC / Passport No. is required",
            v => (v && v.length <= 25) || "IC / Passport No. must be 25 characters or less"
         ],
      }
   },
   watch: {
      errors: {
         immediate: true,
         deep: true,
         handler(errors) {
            if (errors && Object.keys(errors).length) {
               this.fieldErrors = this.normalizeErrors(errors)
               this.errormsg = this.buildErrorMessage(errors)
            }
         }
      }
   },
   methods: {
      formatIcPassport(value) {
         const current = String(value || '').trim()
         if (/[A-Za-z]/.test(current)) {
            return current
         }

         const digits = current.replace(/\D/g, '').slice(0, 12)
         if (digits.length <= 6) {
            return digits
         }
         if (digits.length <= 8) {
            return `${digits.slice(0, 6)}-${digits.slice(6)}`
         }
         return `${digits.slice(0, 6)}-${digits.slice(6, 8)}-${digits.slice(8)}`
      },

      onIcInput(value) {
         this.icno = this.formatIcPassport(value)
         if (this.fieldErrors.icno) {
            this.$delete(this.fieldErrors, 'icno')
         }
      },

      normalizeErrors(errors) {
         const normalized = {}

         if (!errors) {
            return normalized
         }

         Object.keys(errors).forEach(key => {
            normalized[key] = Array.isArray(errors[key]) ? errors[key] : [errors[key]]
         })

         return normalized
      },

      buildErrorMessage(errors) {
         if (!errors || Object.keys(errors).length === 0) {
            return ""
         }

         return Object.keys(errors)
            .map(key => Array.isArray(errors[key]) ? errors[key].join(" ") : errors[key])
            .join(" ")
      },

      register() {
         if (this.submitting) {
            return
         }

         this.errormsg = ""
         this.fieldErrors = {}
         const data = {
            name: this.fname,
            icno: this.formatIcPassport(this.icno),
            email: this.email,
            password: this.password,
            password_confirmation: this.confirm_password
         }

         if (this.$refs.form.validate()) {
            this.submitting = true
            axios.post(this.route('register'), data)
               .then(() => {
                  window.location.href = '/dashboard'
               })
               .catch((error) => {
                  const response = error && error.response ? error.response : null
                  const errors = response && response.data && response.data.errors ? response.data.errors : null

                  if (errors) {
                     this.fieldErrors = this.normalizeErrors(errors)
                     this.errormsg = this.buildErrorMessage(errors)
                     return
                  }

                  this.errormsg = response && response.data && response.data.message
                     ? response.data.message
                     : 'Unable to register. Please check your information and try again.'
               })
               .finally(() => {
                  this.submitting = false
               })
         } else {
            this.errormsg = "Please check the highlighted fields before registering."
         }
      },
   }
}
</script>

